@if(isBrowser) {
<app-header></app-header>
<ng-container [ngSwitch]="desktopTemplate">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="modesmall"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="modesmall"></ng-container>
    <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="modesmall"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="modelgxl"></ng-container>
</ng-container>
<footer></footer>
}

<ng-template #modesmall>
    <div class="headerdwrappermobile">
        <!-- <ng-container *ngTemplateOutlet="breadcrumb"></ng-container> -->
        <div class="headerdbodywrapper">
            <div class="headerdbodyMobile">
                <div class="imgwrapper">
                    <imageslider [data]="images" (clickOnImg)="openImageModal($event)" [current]="0"
                        class="sliderwrapper">
                    </imageslider>
                    <div class="sharwrapper">
                        <button mat-mini-fab (click)="addRemoveToFromFavorite($event)" class="favbtn">
                            <mat-icon class="fav" *ngIf="!inFavorites" matTooltip="Als Favorit markieren">
                                favorite_border
                            </mat-icon>
                            <mat-icon class="fav" *ngIf="inFavorites" matTooltip="Von Favoriten entfernen">favorite
                            </mat-icon>
                        </button>
                        <app-share [shareLink]="shareLink"></app-share>
                    </div>
                    <div class="bildercount mat-elevation-z1">
                        <mat-icon>apps</mat-icon>
                        <span multilang class="bildercounttext">Alle {{images?.length}} Bilder anzeigen</span>
                    </div>
                </div>
                <div class="headerdbodyprcwrapperMobile">
                    <div class="prcwrapperMobile">
                        <div class="f-info">
                            <div class="ratingwrapper">
                                <div class="starrating">
                                    <ng-container *ngFor="let rt of rating;let i = index">
                                        <svg height="16" viewBox="0 0 24 24" width="16"
                                            attr.fill="url(#color-{{i}}-{{ferienHauser.id}})">
                                            <defs>
                                                <linearGradient id="color-{{i}}-{{ferienHauser.id}}">
                                                    <stop offset="0%" stop-color="#2672d7" />
                                                    <stop [attr.offset]="rt" stop-color="#2672d7" />
                                                    <stop [attr.offset]="rt" stop-color="rgb(255, 255, 255)" />
                                                    <stop offset="100%" stop-color="rgb(255, 255, 255)" />
                                                </linearGradient>
                                            </defs>
                                            <path stroke="#000" stroke-width="1"
                                                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                        </svg>
                                    </ng-container>
                                </div>
                            </div>
                            <span multilang class="title">{{ferienHauser?.originalTitle?.length > 0 ?
                                ferienHauser?.originalTitle
                                :
                                ferienHauser?.title }}</span>
                            <div class="info">
                                <span multilang>{{ferienHauser?.guests}} Pers.</span>
                                @if(ferienHauser?.bedrooms > 0) {
                                <span multilang class="spaceline"></span>
                                <span multilang>{{ferienHauser?.bedrooms}} Schlafzimmer</span>
                                }
                                @if(ferienHauser?.size > 0) {
                                <span multilang class="spaceline"></span>
                                <span multilang>{{ferienHauser?.size}} m²</span>
                                }
                                @if(ferienHauser?.petFriendly) {
                                <span multilang class="spaceline"></span>
                                <span multilang>Haustier erlaubt</span>
                                } @else {
                                <span multilang class="spaceline"></span>
                                <span multilang>Haustier nicht erlaubt</span>
                                }
                            </div>

                            <ng-container *ngTemplateOutlet="reisendedatummobile"></ng-container>

                            @if(buchbarok) {
                            <div class="pernight mt2">
                                <span multilang class="custext">Preis pro Nacht</span>
                                <span multilang>{{ferienHauser?.price?.perNight}} €</span>
                            </div>
                            <div class="pernight">
                                <span multilang class="custext">Preis für {{tmp_real?.dauer | number:'1.0-0'}}
                                    {{tmp_real?.dauer === '1' ? 'Tag':
                                    'Tage'}}</span>
                                <span multilang class="fprc">{{ferienHauser?.price?.total| number:'1.2-2'}}
                                    €</span>
                            </div>
                            }

                        </div>
                        <div class="prcbody">
                            @if(loading) {
                            <div class="bbtn noselect" *ngIf="loadingcheck">
                                <span multilang>SUCHE...</span>
                            </div>
                            } @else {
                            @if(this.isFilterchanged) {
                            <button class="bbtnpr noselect" matRipple (click)="checkPreise()">
                                <span multilang>ANGEBOT PRÜFEN</span>
                            </button>
                            } @else {
                            @if(buchbarok) {
                            <button class="bbtn noselect" matRipple (click)="gotoBooking()">
                                <span multilang>ZUR BUCHUNG</span>
                            </button>
                            @if(currentCustomer?.email?.length > 0) {
                            <button class="noselect exp-btn" [class.disabled]="impLoading" matRipple
                                (click)="addToOfferpack()" matTooltip="Zur Angebotsliste hinzufügen">
                                @if(impLoading) {
                                <mat-spinner color="warn" diameter="20"></mat-spinner>
                                } @else {
                                <mat-icon>open_in_new</mat-icon>
                                }
                            </button>
                            }
                            } @else {
                            <div class="bbtmerr noselect">
                                <span multilang>Nicht verfügbar</span>
                            </div>
                            }
                            }
                            }
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="ferienHauser">
                    <clever-ferienhauserofferdetail [ferienHauser]="ferienHauser"></clever-ferienhauserofferdetail>
                </ng-container>
            </div>

        </div>
    </div>
</ng-template>

<ng-template #modelgxl>
    <div class="headerdwrapper">
        <!-- <ng-container *ngTemplateOutlet="breadcrumb"></ng-container> -->
        <div class="headerdbodywrapper">
            <div class="headerdbody">
                <div class="imgwrapper">
                    <imageslider [data]="images" [radiusbottomleft]="true" [radiusbottomright]="true"
                        [radiustopleft]="true" [radiustopright]="true" (clickOnImg)="openImageModal($event)"
                        [current]="0" class="sliderwrapper">
                    </imageslider>
                    <div class="sharwrapper">
                        <app-share [shareLink]="shareLink"></app-share>
                        <button (click)="addRemoveToFromFavorite($event)" class="m-favbtn">
                            <mat-icon class="m-fav" *ngIf="!inFavorites" matTooltip="Als Favorit markieren">
                                favorite_border
                            </mat-icon>
                            <mat-icon class="m-fav" *ngIf="inFavorites" matTooltip="Von Favoriten entfernen">favorite
                            </mat-icon>
                        </button>
                    </div>
                    <button class="bildercount mat-elevation-z1" (click)="openImageModal(0)">
                        <mat-icon>apps</mat-icon>
                        <span multilang class="bildercounttext">Alle {{images?.length}} Bilder anzeigen</span>
                    </button>
                </div>
                <ng-container *ngIf="ferienHauser">
                    <clever-ferienhauserofferdetail [ferienHauser]="ferienHauser"></clever-ferienhauserofferdetail>
                </ng-container>
            </div>
            <div class="headerdbodyprcwrapper">
                <div class="prcwrapper mat-elevation-z1">
                    <div class="f-info">
                        <div class="ratingwrapper">
                            <div class="starrating">
                                <ng-container *ngFor="let rt of rating;let i = index">
                                    <svg height="16" viewBox="0 0 24 24" width="16"
                                        attr.fill="url(#color-{{i}}-{{ferienHauser.id}})">
                                        <defs>
                                            <linearGradient id="color-{{i}}-{{ferienHauser.id}}">
                                                <stop offset="0%" stop-color="#2672d7" />
                                                <stop [attr.offset]="rt" stop-color="#2672d7" />
                                                <stop [attr.offset]="rt" stop-color="rgb(255, 255, 255)" />
                                                <stop offset="100%" stop-color="rgb(255, 255, 255)" />
                                            </linearGradient>
                                        </defs>
                                        <path stroke="#000" stroke-width="1"
                                            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                    </svg>
                                </ng-container>
                            </div>
                        </div>
                        <span multilang class="title">{{ferienHauser?.originalTitle?.length > 0 ?
                            ferienHauser?.originalTitle :
                            ferienHauser?.title }}</span>
                        <div class="info">
                            <span multilang>{{ferienHauser?.guests}} Pers.</span>
                            @if(ferienHauser?.bedrooms > 0) {
                            <span multilang class="spaceline"></span>
                            <span multilang>{{ferienHauser?.bedrooms}} Schlafzimmer</span>
                            }
                            @if(ferienHauser?.size > 0) {
                            <span multilang class="spaceline"></span>
                            <span multilang>{{ferienHauser?.size}} m²</span>
                            }
                            @if(ferienHauser?.petFriendly) {
                            <span multilang class="spaceline"></span>
                            <span multilang>Haustier erlaubt</span>
                            } @else {
                            <span multilang class="spaceline"></span>
                            <span multilang>Haustier nicht erlaubt</span>
                            }
                        </div>

                        <ng-container *ngTemplateOutlet="reisendedatum"></ng-container>

                        @if(buchbarok) {
                        <div class="pernight mt2">
                            <span multilang class="custext">Preis pro Nacht</span>
                            <span multilang>{{ferienHauser?.price?.perNight}} €</span>
                        </div>
                        <div class="pernight">
                            <span multilang class="custext">Preis für {{tmp_real?.dauer | number:'1.0-0'}}
                                {{tmp_real?.dauer === '1' ? 'Tag':
                                'Tage'}}</span>
                            <span multilang class="fprc">{{ferienHauser?.price?.total| number:'1.2-2'}} €</span>
                        </div>
                        }

                    </div>
                    <div class="prcbody">
                        @if(loading) {
                        <div class="bbtn noselect" *ngIf="loadingcheck">
                            <span multilang>SUCHE...</span>
                        </div>
                        } @else {
                        @if(this.isFilterchanged) {
                        <button class="bbtnpr noselect" matRipple (click)="checkPreise()">
                            <span multilang>ANGEBOT PRÜFEN</span>
                        </button>
                        } @else {
                        @if(buchbarok) {
                        <button class="bbtn noselect" matRipple (click)="gotoBooking()">
                            <span multilang>ZUR BUCHUNG</span>
                        </button>
                        @if(currentCustomer?.email?.length > 0) {
                        <button class="noselect exp-btn" [class.disabled]="impLoading" matRipple
                            (click)="addToOfferpack()" matTooltip="Zur Angebotsliste hinzufügen">
                            @if(impLoading) {
                            <mat-spinner color="warn" diameter="20"></mat-spinner>
                            } @else {
                            <mat-icon>open_in_new</mat-icon>
                            }
                        </button>
                        }
                        } @else {
                        <div class="bbtmerr noselect">
                            <span multilang>Nicht verfügbar</span>
                        </div>
                        }
                        }
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #importloading>
    <button class="exp-btn noselect">
        <mat-spinner color="warn" diameter="20"></mat-spinner>
    </button>
</ng-template>

<ng-template #fnormal>
    <button class="bbtn noselect" matRipple *ngIf="!loadingcheck && offer.buchbarok" (click)="gotoBooking()">
        <span multilang>ZUR BUCHUNG</span>
    </button>
</ng-template>

<ng-template #breadcrumb>
    <div class="breadcrumb">
        <!-- <ng-container *ngIf="ferienHauser?.country_code?.length > 0">
                    <span  multilang   class="crumg crumgactive" (click)="gotoLand()">{{ferienHauser?.country}}</span>
                    <span  multilang   *ngIf="ferienHauser?.region?.length > 0" class="crumg crumgactive" (click)="gotoRegion()">
                        <mat-icon class="crugico">chevron_right</mat-icon> {{ferienHauser?.region}}
                    </span>
                    <span  multilang   *ngIf="ferienHauser?.city?.length > 0" class="crumg crumgactive" (click)="gotoCity()">
                        <mat-icon class="crugico">chevron_right</mat-icon> {{ferienHauser?.city}}
                    </span>
                    <span  multilang   class="crumg">
                        <mat-icon class="crugico">chevron_right</mat-icon> {{ferienHauser?.id}}
                    </span>
                </ng-container> -->
    </div>
</ng-template>

<ng-template #loadprc>
    <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
</ng-template>

<ng-template #loadingprog>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #criteria>
    <div class="datesection">
        <div class="datesectionAn" [class.borderFix]="startDate">
            <div class="datesectionAbDateWrapper">
                <span multilang class="sectiontxt">ANREISE</span>
                <span multilang class="datesectionAnDate">{{ferienFiltersService?.start |
                    date:'MMM d, y'
                    }}</span>
            </div>
        </div>
        <div style="display: flex;">
            <mat-icon>east</mat-icon>
        </div>
        <div class="datesectionAb" [class.borderFix]="endDate">
            <div class="datesectionAbDateWrapper">
                <span multilang class="sectiontxt">ABREISE</span>
                <span multilang class="datesectionAbDate">{{ferienFiltersService?.end | date:'MMM d, y'
                    }}</span>
            </div>
        </div>
    </div>
    <div class="wuwrp">
        <a multilang [href]="ferienHauser?.link" target="_blank">weitere Verfügbarkeiten</a>
    </div>

    <!-- <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="originZeit"
            [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="isOpenZeit"
            [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'transparent'"
            (backdropClick)="toggleDropdownZeit($event)">
            <div class="mat-elevation-z1">
                <clever-cleverdatepicker [start]="ferienFiltersService.start" [end]="ferienFiltersService.end"
                    (sendRes)="changeDate($event)" class="w100">
                </clever-cleverdatepicker>
            </div>
        </ng-template> -->
</ng-template>

<ng-template #criteriamobile>
    <div class="datesection">
        <div class="datesectionAn" [class.borderFix]="startDate">
            <div class="datesectionAbDateWrapper">
                <span multilang class="sectiontxt">ANREISE</span>
                <span multilang class="datesectionAnDate">{{ferienFiltersService?.start |
                    date:'MMM d, y'
                    }}</span>
            </div>
        </div>
        <div style="display: flex;">
            <mat-icon>east</mat-icon>
        </div>
        <div class="datesectionAb" [class.borderFix]="endDate">
            <div class="datesectionAbDateWrapper">
                <span multilang class="sectiontxt">ABREISE</span>
                <span multilang class="datesectionAbDate">{{ferienFiltersService?.end | date:'MMM d, y'
                    }}</span>
            </div>
        </div>
    </div>
    <div class="wuwrp">
        <a multilang [href]="ferienHauser?.link" target="_blank">weitere Verfügbarkeiten</a>
    </div>

    <!-- <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="originZeit"
            [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="isOpenZeit"
            [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'transparent'"
            (backdropClick)="toggleDropdownZeit($event)">
            <div class="backdropwrapper-mobile">
                <div class="modal-mobile-header">
                    <button matRipple (click)="toggleDropdownZeit($event)">
                        <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                    </button>
                    <span  multilang >{{ferienFiltersService.start | date:'dd.MM.yyyy'}} - {{ferienFiltersService.end |
                        date:'dd.MM.yyyy'}}</span>
                    <button class="emptybtn"></button>
                </div>
                <div class="filterwrapper-mobile">
                    <clever-cleverdatepicker [start]="ferienFiltersService.start" [end]="ferienFiltersService.end"
                        (sendRes)="changeDate($event)" class="w100">
                    </clever-cleverdatepicker>
                </div>
            </div>
        </ng-template> -->
</ng-template>

<ng-template #reisendedatum>
    <div class="cc10">
        <ng-container *ngTemplateOutlet="criteria"></ng-container>
        <div class="cc3">
            <span multilang class="cc6">Erwachsene</span>
            <div class="cc4">
                <button matRipple class="cc5 mr1" [class.disabled]="this.ferienFiltersService?.adults === 1"
                    (click)="removeAdult()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.adults}}</div>
                <button matRipple class="cc5 ml1"
                    [class.disabled]="(this.ferienFiltersService?.adults + this.ferienFiltersService?.children) === this.ferienHauser?.guests"
                    (click)="addAdult()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
        <div class="cc3">
            <span multilang class="cc6">Kinder</span>
            <div class="cc4">
                <button matRipple class="cc5 mr1" [class.disabled]="this.ferienFiltersService?.children === 0"
                    (click)="removeChildren()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.children}}</div>
                <button matRipple class="cc5 ml1"
                    [class.disabled]="(this.ferienFiltersService?.adults + this.ferienFiltersService?.children) === this.ferienHauser?.guests"
                    (click)="addChildren()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
        @if(ferienFiltersService.childrenAges?.length > 0) {
        <div class="cc9">
            @for (item of ferienFiltersService.childrenAges; let k=$index; track k) {
            <select class="cc8" [(ngModel)]="ferienFiltersService.childrenAges[k]" (ngModelChange)="changeAge()">
                <option value="-1">Alter {{k + 1}}</option>
                @for (ag of ages; track $index) {
                <option [value]="ag">{{ag === 1 ? ag + ' Jahr alt' : ag + ' Jahre alt'}}</option>
                }
            </select>
            }
        </div>
        }
    </div>
</ng-template>

<ng-template #reisendedatummobile>
    <div class="c10mobile">
        <ng-container *ngTemplateOutlet="criteriamobile"></ng-container>
        <div class="cc3">
            <span multilang class="cc6">Erwachsene</span>
            <div class="cc4">
                <button matRipple class="cc5 mr1" [class.disabled]="this.ferienFiltersService?.adults === 1"
                    (click)="removeAdult()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.adults}}</div>
                <button matRipple class="cc5 ml1"
                    [class.disabled]="(this.ferienFiltersService?.adults + this.ferienFiltersService?.children) === this.ferienHauser?.guests"
                    (click)="addAdult()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
        <div class="cc3">
            <span multilang class="cc6">Kinder</span>
            <div class="cc4">
                <button matRipple class="cc5 mr1" [class.disabled]="this.ferienFiltersService?.children === 0"
                    (click)="removeChildren()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.children}}</div>
                <button matRipple class="cc5 ml1"
                    [class.disabled]="(this.ferienFiltersService?.adults + this.ferienFiltersService?.children) === this.ferienHauser?.guests"
                    (click)="addChildren()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
        @if(ferienFiltersService.childrenAges?.length > 0) {
        <div class="cc9">
            @for (item of ferienFiltersService.childrenAges; let k=$index; track k) {
            <select class="cc8" [(ngModel)]="ferienFiltersService.childrenAges[k]" (ngModelChange)="changeAge()">
                <option value="-1">Alter {{k + 1}}</option>
                @for (ag of ages; track $index) {
                <option [value]="ag">{{ag === 1 ? ag + ' Jahr alt' : ag + ' Jahre alt'}}</option>
                }
            </select>
            }
        </div>
        }
    </div>
</ng-template>